import { Component, OnInit, OnDestroy, AfterViewInit, computed, signal, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum FestivalType {
  NONE = 'none',
  CHRISTMAS = 'christmas',
  NEW_YEAR = 'new_year',
  EASTER = 'easter',
  HALLOWEEN = 'halloween',
  DIWALI = 'diwali',
  THANKSGIVING = 'thanksgiving'
}

@Component({
  selector: 'app-sidebar-festival-decoration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar-festival-decoration.html',
  styleUrl: './sidebar-festival-decoration.scss'
})
export class SidebarFestivalDecoration implements OnInit, AfterViewInit, OnDestroy {
  @Input() showTree = true;
  @Input() showSanta = false;

  currentMonth = signal<number>(new Date().getMonth() + 1); // 1-12
  isScrolled = signal<boolean>(false);
  
  festivalType = computed<FestivalType>(() => {
    const month = this.currentMonth();
    switch (month) {
      case 12: // December
        return FestivalType.CHRISTMAS;
      case 1: // January
        return FestivalType.NEW_YEAR;
      case 4: // April
        return FestivalType.EASTER;
      case 10: // October
        return FestivalType.HALLOWEEN;
      case 11: // November
        return FestivalType.THANKSGIVING;
      default:
        return FestivalType.NONE;
    }
  });

  showFestival = computed(() => this.festivalType() !== FestivalType.NONE);
  isChristmas = computed(() => this.festivalType() === FestivalType.CHRISTMAS);

  private scrollListener?: () => void;

  ngOnInit(): void {
    // Update month periodically to handle month changes
    this.updateMonth();
    setInterval(() => this.updateMonth(), 60000); // Check every minute
  }

  ngAfterViewInit(): void {
    // Find the scrollable sidebar container with a small delay to ensure DOM is ready
    setTimeout(() => {
      this.setupScrollListener();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.scrollListener) {
      this.scrollListener();
    }
  }

  private setupScrollListener(): void {
    // Find the side_bar_wrap element (scrollable container)
    const sidebarWrap = document.querySelector('.side_bar_wrap') as HTMLElement;
    if (sidebarWrap) {
      const handleScroll = () => {
        const scrollTop = sidebarWrap.scrollTop;
        this.isScrolled.set(scrollTop > 10); // Hide santa if scrolled more than 10px
      };

      sidebarWrap.addEventListener('scroll', handleScroll, { passive: true });
      this.scrollListener = () => {
        sidebarWrap.removeEventListener('scroll', handleScroll);
      };

      // Check initial scroll position
      handleScroll();
    } else {
      // Retry if element not found (might be due to timing)
      setTimeout(() => this.setupScrollListener(), 200);
    }
  }

  private updateMonth(): void {
    this.currentMonth.set(new Date().getMonth() + 1);
  }
}

